import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChildren, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GetArticlesService } from 'src/app/services/get-articles.service';
import { MainBodyService } from 'src/app/services/main-body.service';
import { themeData } from 'src/interface/themesetting';
import { JournalService } from '../../journal.service';

@Component({
    selector: 'app-article-filters',
    templateUrl: './article-filters.component.html',
    styleUrls: ['./article-filters.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ArticleFiltersComponent implements OnInit, OnDestroy, OnChanges {
    valueForSearch: string;
    sortCriteria: string;
    showkeywords: boolean;
    search_filters: string[] = [];
    fitlerVisibility = false;
    isChevronUp: boolean[] = [true, true, true, true, true, true];
    themeSettingsData: themeData;
    highlightcolor: string;
    subscriptions: Subscription[] = [];
    clearButton = false;
    @ViewChildren('showref', { read: ElementRef }) showref;

    @Input() uncheck: boolean[] = [];
    @Input() journalId: string;
    @Input() keywordFIlter: boolean;
    @Input() journal_id: string;
    @Input() subject_area_filter: boolean;
    @Input() volume: string;
    @Input() issue: string;
    @Input() volumeIssue:boolean = true;
    @Output() emitCheck = new EventEmitter<string[]>();
    @Output() clear_emit = new EventEmitter<boolean>();
    @Output() sort_emit = new EventEmitter<string>();
    @Output() keyword_click = new EventEmitter<boolean>();
    @Output() volumeEmit = new EventEmitter<string>();
    @Output() issueEmit = new EventEmitter<string>();

    volumeData: string[] = [];
    issueData: string[] = [];
    selectedVolume;
    public selectForm = new FormGroup({
        volumeSelect: new FormControl(),
        issueSelect: new FormControl()
    });
    selectData: { volumeSelect: FormControl; issueSelect: FormControl };

    constructor(
        private mainBodyService: MainBodyService,
        private articleService: GetArticlesService,
        private journalService: JournalService,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    ngOnInit(): void {
        
        const journalType = { jnl_type: "JNL" }
        if (this.journalId === undefined) {
            this.journalService.getJournals(journalType).subscribe((result) => {
                this.journal_id = result.data[0].id;
                this.journalId = result.data[0].id;

                if (this.journal_id) {
                    const themeSub = this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result) => {
                        if (result.data) {
                            this.themeSettingsData = result.data;
                            const color = this.themeSettingsData.theme_colors;
                            if (isPlatformBrowser(this.platformId)) {
                                Object.entries(color).map(([key, value]) => {
                                    const element = "--" + key;
                                    const val = value;
                                    document.documentElement.style.setProperty(element, val);
                                });
                            }
                        }
                    });
                    this.subscriptions.push(themeSub);
                    const volumeIssue = {
                        journal_id: this.journal_id,
                        volume: ''
                    }
                    this.volumeData.push('Volume');
                    if (!this.issueData.includes('Issue')) {
                        this.issueData.push('Issue');
                    }
                    const volumeSub = this.articleService.getVolumeIssue(volumeIssue).subscribe((result) => {
                        if (result.data) {
                            result.data.forEach(element => {
                                this.volumeData.push(element.id)
                            });
                        }
                    });
                    this.subscriptions.push(volumeSub);
                }
            })

        }
        else {
            const volumeIssue = {
                journal_id: this.journal_id,
                volume: ''
            }
            this.volumeData.push('Volume');
            if (!this.issueData.includes('Issue')) {
                this.issueData.push('Issue');
            }
            const volumeSub = this.articleService.getVolumeIssue(volumeIssue).subscribe((result) => {
                if (result.data) {
                    result.data.forEach(element => {
                        this.volumeData.push(element.id)
                    });
                }
            });
            this.subscriptions.push(volumeSub);
        }
        // this.selectForm = new FormGroup({
        //     volumeSelect: new FormControl('Volume'),
        //     issueSelect: new FormControl('Issue')
        // })
        // this.selectData = {
        //     volumeSelect: this.selectForm.get('volumeSelect') as FormControl,
        //     issueSelect: this.selectForm.get('issueSelect') as FormControl
        // };
    }

    clearAllCheckbox() {
        this.uncheck = [false, false, false, false];
        this.selectForm.get('volumeSelect')?.setValue('Volume');
        this.selectForm.get('issueSelect')?.setValue('Issue');
        this.volumeEmit.emit('');
        this.issueEmit.emit('');
        this.clear_emit.emit(true);
        this.clearButton=false;
    }

    checkBoxChange(event: Event, field: string) {

        const ind = this.search_filters.findIndex(x => x === (event.target as HTMLInputElement).value);
        this.uncheck[field] = (event.target as HTMLInputElement).checked;
        this.clearButton = true;
        if (ind == -1 && (event.target as HTMLInputElement).checked) {
           
            this.search_filters.push((event.target as HTMLInputElement).value);
        }
        if ((event.target as HTMLInputElement).checked === false && ind !== -1) {
            this.search_filters.splice(ind, 1);
            if (Object.values(this.uncheck).every(value => !value)) {
                this.clearButton = false;
            }
        }
        this.emitCheck.emit(this.search_filters);
    }
    // toggleSort(sortField: string, i: number) {
    //     this.isChevronUp[i] = !this.isChevronUp[i];
    //     this.isChevronUp.fill(true, 0, i);
    //     const sortBy = this.isChevronUp[i] ? 'ASC' : 'DESC';
    //     this.sortCriteria = sortField + ':' + sortBy;
    //     this.sort_emit.emit(this.sortCriteria);
    // }
    showKeywordDiv() {
        this.showkeywords = !this.showkeywords;
        this.keyword_click.emit(this.showkeywords);
    }
    ngOnDestroy() {
        this.subscriptions?.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }
    getIssues() {
        this.issueData =[];
        if (!this.issueData.includes('Issue')) {
            this.issueData.push('Issue');
        }
        this.clearButton=true;
        this.selectedVolume = this.selectForm.get('volumeSelect')?.value;
        this.volumeEmit.emit(this.selectForm.get('volumeSelect')?.value);
        const volumeIssue = {
            journal_id: this.journal_id,
            volume: this.selectedVolume
        }
        const issueSub = this.articleService.getVolumeIssue(volumeIssue).subscribe((result) => {
            if (result.data) {
                result.data.forEach(element => {
                    if (!this.issueData.includes(element.issue)) {
                        this.issueData.push(element.issue);
                    }
                });
            }
        });
        this.subscriptions.push(issueSub);
    }
    getData() {
        this.clearButton=true;
        this.issueEmit.emit(this.selectForm.get('issueSelect')?.value);
        // this.issueEmit.emit(issue);
    }
    ngOnChanges(): void {
        if (this.volume != '') {
            this.selectForm = new FormGroup({
                volumeSelect: new FormControl(this.volume),
                issueSelect: new FormControl('Issue')
            })
            this.selectData = {
                volumeSelect: this.selectForm.get('volumeSelect') as FormControl,
                issueSelect: this.selectForm.get('issueSelect') as FormControl
            };
            this.getIssues();
        }
        if (this.issue != '') {
            this.selectForm = new FormGroup({
                volumeSelect: new FormControl(this.volume),
                issueSelect: new FormControl(this.issue)
            })
            this.selectData = {
                volumeSelect: this.selectForm.get('volumeSelect') as FormControl,
                issueSelect: this.selectForm.get('issueSelect') as FormControl
            };
        }
        if (this.issue == '') {
            this.selectForm = new FormGroup({
                volumeSelect: new FormControl('Volume'),
                issueSelect: new FormControl('Issue')
            })
            this.selectData = {
                volumeSelect: this.selectForm.get('volumeSelect') as FormControl,
                issueSelect: this.selectForm.get('issueSelect') as FormControl
            };
        }
        // if(this.journal_id){
        //     this.selectForm.get('volumeSelect')?.setValue('Volume');
        //     this.selectForm.get('issueSelect')?.setValue('Issue');
        // }
        if (this.articleService.clearSearch === true) {
            this.uncheck = [false, false, false, false];
            this.selectForm.get('volumeSelect')?.setValue('Volume');
            this.selectForm.get('issueSelect')?.setValue('Issue');
        }
    }
   
    changeIssue(issue: any) {
        // Regular expression pattern to match 'and'
        const pattern = /and/;
        let outputString: string = issue.match(/Issue/)? issue:'Issue ' + issue;
        if (issue.match(pattern)) {
            // Replace 'and' with '/'
            outputString = 'Issue ' + issue.replace(pattern, ' & ');
        }

        // Regular expression pattern to match 's' followed by a number
        const nextpattern = /s(\d+)/;

        if (issue.match(nextpattern)) {
            const issue_num =issue.match(nextpattern)[1];
            // Replace 's' followed by a number with 'supplementary issue' followed by that number
            outputString = issue.replace(nextpattern, 'Supplementary issue ' + issue_num);
        }

        if(issue == 'non-issue'){
            outputString = 'Regular articles';
        }
        
        return outputString;
    }

    showFilterOptions() {        
        this.fitlerVisibility = true;
        const elementdflex = this.showref.first.nativeElement;
        const length = elementdflex.children.length;
        const index = elementdflex.classList.contains('d-flexmd');
        const action = index ? 'remove' : 'add';
        const highlightColor = index ? '#000000' : '#18161633';
        this.highlightcolor = highlightColor;
        elementdflex.classList[action]('d-flexmd');

        for (let i = 2; i < length - 1; i++) {
            const element = this.showref.first.nativeElement.children[i];
            if (element) {
                const classAction = index ? 'add' : 'remove';
                element.classList[classAction]('d-md-none', 'd-none');
            }
        }
    }

}
